import React, {useState} from 'react';
import Header from "../components/Header";
import {useWebPSupportCheck} from "react-use-webp-support-check";
import FirstSection from "../components/About/FirstSection";
import AboutUs from "../components/About/AboutUs";
import OurGoal from "../components/About/OurGoal";
import ProductsAndServices from "../components/About/ProductsAndServices";
import { ParallaxProvider } from 'react-scroll-parallax';
import {observer} from "mobx-react-lite";
import Seo from "../components/Seo";
import Loader from "../components/Loader";

import bgwebp from "../img/bg.webp";
import bgpng from "../img/bg.png";

const AboutPage = () => {
    const supportsWebP = useWebPSupportCheck();
    const [loading, setLoading] = useState(true)

    return (
        <ParallaxProvider>
            <Seo page='about' />
            <div className="container_fluid">
                <div className="about_us background" style={{backgroundImage: `url(${supportsWebP ? bgwebp : bgpng})`}}>
                    <Header />
                    <FirstSection setLoading={setLoading} />
                    {loading ? <Loader /> : <>
                        <AboutUs />
                        <OurGoal />
                        <ProductsAndServices />
                    </> }
                </div>
            </div>
        </ParallaxProvider>
    );
};

export default observer(AboutPage);